import React, { memo } from 'react'
import { toSnakeCaseText } from '../utils/articleFilters'

const Tag = ({ text, type }) => {
  return <div className={`tag tag-${toSnakeCaseText(type)}`}>{text}</div>
}

export default memo(Tag)
